<template>
  <div class="personalReport">
    <div class="title">{{ report.name }}<Back /></div>

    <div class="reportInfo">
      <div>
        <div>报告名称：{{ report.name }}</div>
        <div>
          生成时间：{{
            report.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </div>
        <div>报告备注：{{ report.remark }}</div>
      </div>
      <div class="btns">
        <Btn
          btnText="查看报告"
          @handleClick="checkReport"
          :width="77.7"
          :height="30"
          :fontWeight="600"
          style="margin-right:18px;"
        />
        <Btn
          btnText="删除报告"
          @handleClick="handleConfirm('报告', report.id)"
          :width="77.7"
          :height="30"
          :fontWeight="600"
          className="primary_plain"
        />
      </div>
    </div>

    <div class="subTitle">
      所有电子证书
      <div class="etc_tip">
        <i class="icon_warning"></i
        >每份个人信息报告可生成多个授权查验的电子证书；
        <br />
        每份电子证书可单独设置授权时间和次数，被授权者扫码即可查验您的个人信息报告。
      </div>
    </div>

    <div class="dataTable">
      <div class="tabList">
        <span
          :class="`tabItem ${listQuery.status ? 'active' : ''}`"
          @click="handleTypeChange(true)"
          >生效中</span
        >
        <span
          :class="`tabItem ${!listQuery.status ? 'active' : ''}`"
          @click="handleTypeChange(false)"
          >已失效</span
        >
      </div>
      <Btn
        btnText="新建证书"
        :plus="true"
        className="default"
        :width="126"
        :height="39"
        @handleClick="handleAddEtc"
      />
    </div>

    <div class="list" v-if="list && list.length > 0">
      <div class="item" v-for="item in list" :key="item.id">
        <div>
          <div>证书名称：{{ item.name }}</div>
          <div>
            访问次数/授权次数：<span class="r16">{{ item.usedTimes }}</span
            >/{{
              item.authorizationTimes === null
                ? "不限次数"
                : item.authorizationTimes
            }}
          </div>
          <!-- <div v-if="item.endDate">
            授权期限：{{ item.endDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
          </div>
          <div v-else>授权期限：不限时间</div> -->
          <div v-if="item.whiteList">
            授权对象：<span class="r16">{{
              item.whiteList.split(",").length
            }}</span>
            人
          </div>
          <div v-else>
            授权对象：不限
          </div>
        </div>
        <div>
          <div>
            生成时间：{{
              item.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
            }}
          </div>
          <div>
            状态：<span class="status">{{ item.status | statusFilter }}</span>
          </div>
          <div v-if="item.endDate">
            授权期限：{{ item.endDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
          </div>
          <div v-else>授权期限：不限时间</div>
        </div>
        <div class="btns">
          <router-link
            :to="{
              path: '/reportPreview',
              query: { id: item.id, type: 1, active: 1 }
            }"
            @click="handleCheckEtc"
            >查看/分享证书</router-link
          >
          <span v-if="item.whiteList" @click="handleWhiteList(item.whiteList)"
            >查看授权对象</span
          >
          <span @click="handleVisitRecord(item.id)">查看访客</span>
          <span @click="handleConfirm('证书', item.id)">作废证书</span>
        </div>
      </div>
    </div>
    <no-data v-else top="0px" />

    <div class="confirmDeleteAll" v-if="confirmDeleteAll">
      <CoverLayout>
        <div slot="content" class="confirmBox">
          <div class="title">
            {{
              `确定${
                deletePayload.type === "报告" ? "删除该报告" : "作废该证书"
              }吗？`
            }}
          </div>
          <div class="text">
            {{
              `${
                deletePayload.type === "报告"
                  ? "删除报告后该报告生成的电子证书均会失效，是否确认删除报告？"
                  : "作废证书后他人均无法通过授权查看报告，是否确认作废该证书？"
              }`
            }}
          </div>
          <div class="btns">
            <Btn
              btnText="取消"
              className="default"
              :width="100"
              :height="41"
              @handleClick="confirmDeleteAll = false"
            />
            <Btn
              btnText="确定"
              className="primary"
              :width="100"
              :height="41"
              @handleClick="
                deletePayload.type === '报告'
                  ? handleDeleteReport(deletePayload.value)
                  : handleEtcDiscard(deletePayload.value)
              "
            />
          </div>
        </div>
      </CoverLayout>
    </div>

    <div v-if="dialogWhiteList">
      <CoverLayout>
        <div slot="content" class="whiteList">
          <div class="title">授权对象</div>
          <div class="wList">
            <div class="wItem" v-for="(item, index) in whiteList" :key="index">
              {{ item + "；" }}
            </div>
          </div>
          <Btn
            btnText="关闭"
            @handleClick="closeDialogWhiteList"
            :width="108"
            :height="37"
          />
        </div>
      </CoverLayout>
    </div>
  </div>
</template>

<script>
import { etcList, etcDiscard, reportDelete } from "@/api/report";
import Btn from "@/components/Btn";
import NoData from "../../../components/NoData.vue";
import CoverLayout from "../../../components/CoverLayout.vue";
import Back from "../../../components/Back.vue";
export default {
  components: { Btn, NoData, CoverLayout, Back },
  filters: {
    statusFilter(status) {
      const statusMap = {
        IN_EFFECT: "生效中",
        TIMEOUT: "已超时",
        DISCARD: "已作废",
        RUN_OUT_OF_TIMES: "次数已失效"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: [],
      report: JSON.parse(localStorage.getItem("report")),
      listQuery: {
        reportId: JSON.parse(localStorage.getItem("report")).id,
        status: true
      },
      confirmDeleteAll: false,
      deletePayload: {
        type: ""
      },
      dialogWhiteList: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      etcList(this.listQuery).then(res => {
        console.log(res);
        this.list = res.data.d;
      });
    },
    handleVisitRecord(id) {
      this.$router.push({ path: "credentialsDetail", query: { id } });
    },
    handleAddEtc() {
      this.$router.push("create");
    },
    handleTypeChange(status) {
      this.listQuery.status = status;
      this.getList();
    },
    handleConfirm(type, id) {
      this.deletePayload = {
        type: type,
        value: id
      };
      this.confirmDeleteAll = true;
    },
    handleEtcDiscard(id) {
      etcDiscard(id).then(res => {
        if (res.data.c === 200) {
          this.$message.success("操作成功");
          this.confirmDeleteAll = false;
          this.getList();
        }
      });
    },
    handleCheckEtc() {
      console.log("handleCheckEtc");
    },
    handleDeleteReport(id) {
      reportDelete({ id }).then(res => {
        if (res.data.c === 200) {
          this.$router.go(-1);
          this.$message.success("删除成功");
          this.confirmDeleteAll = false;
        }
      });
    },
    checkReport() {
      this.$router.push({
        path: "/reportPreview",
        query: { id: this.report.id, type: 1, active: 2 }
      });
    },
    handleWhiteList(strWList) {
      this.whiteList = strWList.split(",");
      this.dialogWhiteList = true;
    },
    closeDialogWhiteList() {
      this.dialogWhiteList = false;
    }
  }
};
</script>

<style scoped lang="scss">
.personalReport {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  // .el-table th.el-table__cell {
  //   background-color: #f0f2f5;
  // }
  .subTitle {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #393939;
    line-height: 41px;
    display: flex;
    flex-direction: column;

    .etc_tip {
      display: flex;
      // align-items: center;
      // margin-left: 18px;
      margin-top: 5px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ff8d65;
      line-height: 24px;
      align-items: baseline;
      .icon_warning {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
          no-repeat;
        background-size: cover;
        display: inline-block;
        margin-right: 9px;
        width: 16px;
        height: 16px;
        position: relative;
        top: 2px;
      }
    }
  }
  .reportInfo {
    padding: 36px 45px;
    display: flex;
    background: #f0f2f5;
    border-radius: 2px;
    justify-content: space-between;
    line-height: 27px;
    font-size: 14px;
    margin-top: 11px;
    margin-bottom: 32px;
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
  }
  .detail {
    color: #338ff7;
  }
  .btns {
    display: flex;
    align-items: center;
    a {
      color: #338ff7;
      text-decoration: initial;
    }
    .btn_primary {
      background: #3a61b1;
      color: #fff;
      border: 0;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
    .btn_primary_plain {
      color: #3a61b1;
      background: #f0f2f5;
      border: 1px solid #3a61b1;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
  }
  .btn_default {
    width: 126px;
    height: 39px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 20px;
  }
  .dataTable {
    margin-top: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabList {
      .tabItem {
        color: #6e6e6e;
        font-size: 16px;
        margin-right: 42px;
        cursor: pointer;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 30px;
      }
      .active {
        color: #3a61b1;
      }
    }
  }
  .list {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #6e6e6e;
    .item {
      padding: 30px 32px 35px 34px;
      line-height: 29px;
      border: 1px solid #f1f1f1;
      margin-bottom: 19px;
      display: flex;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
      .btns {
        color: #338ff7;
        flex-direction: column;
        span {
          cursor: pointer;
        }
      }
      .status {
        color: #ff5129;
      }
      .r16 {
        color: #ff5129;
        font-size: 16px;
      }
    }
  }
  .confirmBox {
    background: #fff;
    width: 430px;
    height: 226px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #393939;
      line-height: 41px;
    }
    .text {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #8d8d8d;
      line-height: 24px;
    }
    .btns {
      margin-top: 31px;
      button {
        &:last-child {
          margin-left: 35px;
        }
      }
    }
  }
}
.whiteList {
  background: #fff;
  width: 393px;
  height: 203px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 16px;
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #393939;
  }
  .wList {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 25px;
    .wItem {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/report/credentialsList.vue